import React from 'react';
import { useReveal } from '../lib/useReveal';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/uaZdCuVEFzhNFpXgAbYiip/ChatGPT_Image_26_may_2026,_15_25_57.png';
const PILLS = ['100% Digital', 'Acceso Inmediato', 'Desde Cero', 'A Tu Ritmo', 'Ideal para Emprender', 'Recetas Premium'];
export function HeroSection() {
  const [ref, isVisible] = useReveal();
  return <section className="relative pt-6 pb-8 md:pt-10 md:pb-10 px-4 overflow-hidden bg-gradient-to-b from-[#fdf2f4] to-[#fff8f9]" data-id="element-137">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-138">
        <div className="absolute -top-[20%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#fce7e9] blur-[120px] opacity-70" data-id="element-139"></div>
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#f8d7da] blur-[120px] opacity-50" data-id="element-140"></div>
      </div>

      <div ref={ref} className={`reveal max-w-3xl mx-auto flex flex-col items-center text-center ${isVisible ? 'is-visible' : ''}`} data-id="element-141">
        <span className="inline-block py-1 px-3 rounded-full bg-white/70 border border-[#e89aaa]/30 text-[#8b6f47] text-[10px] font-semibold tracking-widest uppercase mb-3 shadow-sm" data-id="element-142">
          ♡ Pastelería Premium ♡
        </span>

        <h1 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold text-[#6b4f3a] leading-[1.05] mb-3" data-id="element-143">
          Aprendé Pastelería{' '}
          <span className="italic text-[#e89aaa]" data-id="element-144">y empezá a vender</span> desde
          casa.
        </h1>

        <div className="w-full max-w-[280px] sm:max-w-xs md:max-w-sm my-2" data-id="element-145">
          <img src={HERO_MOCKUP} alt="MegaPack Pastelería Premium" className="w-full h-auto animate-float" data-id="element-146" />
        </div>

        <p className="text-sm md:text-base text-[#8b6f47] max-w-md leading-snug" data-id="element-147">
          El MegaPack premium con{' '}
          <span className="font-serif italic text-[#e89aaa] font-semibold" data-id="element-148">
            6 Tomos + 6 Bonos
          </span>{' '}
          para aprender pastelería moderna y emprender desde casa.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 mt-3 mb-3 max-w-xl" data-id="element-149">
          {PILLS.map((pill, i) => <span key={i} className="flex items-center gap-1 text-[10px] md:text-xs text-[#8b6f47] bg-white border border-[#f4b6c2]/40 rounded-full px-2.5 py-1 shadow-sm" data-id="element-150">
              <span className="text-[#e89aaa]" data-id="element-151">✓</span> {pill}
            </span>)}
        </div>

        <div className="flex flex-col items-center gap-2 mt-2" data-id="element-152">
          <a href="#cta" className="cta-btn inline-block px-8 py-3.5 rounded-full bg-[#e89aaa] hover:bg-[#d98ba0] text-white font-medium text-sm md:text-base tracking-wider text-center shadow-[0_8px_20px_rgba(232,154,170,0.35)] hover:shadow-[0_12px_25px_rgba(232,154,170,0.45)]" data-id="element-153">
            QUIERO ACCEDER AL MEGAPACK ♡
          </a>
          <p className="text-[10px] text-[#8b6f47]/70 tracking-wider uppercase" data-id="element-154">
            🔒 Pago seguro · ⚡ Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}